import { render, staticRenderFns } from "./ShippingsCards.vue?vue&type=template&id=5a424598&"
import script from "./ShippingsCards.vue?vue&type=script&lang=js&"
export * from "./ShippingsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports